import React from 'react';
import { Field } from 'redux-form';
import renderDropbox from './form-dropbox';
import { Form } from 'semantic-ui-react';
import {
  getDays,
  getMonths,
  getYears,
} from '../../utils/dates';

const renderDate = (fields) => {
  const { label, groupName, customClass, errorMessage, invalidErrorMessage, onClick, required } = fields;
  let { month, year, day } = fields;
  let fieldGroupName = '';
  if (groupName) {
    month = fields[groupName].month;
    year = fields[groupName].year;
    day = fields[groupName].day;
    fieldGroupName = `${groupName}.`;
  }

  const showError = (month.meta.touched || year.meta.touched || day.meta.touched) &&
    (month.meta.error || year.meta.error || day.meta.error);
  return (
    <Form.Group className={ `multiple-inputs ${customClass || ''} ${showError ? 'error' : ''}` }>
      <label className={ required ? 'required' : '' }>{label}</label>
      <div className="date">
        <Field
          name={ `${fieldGroupName}month` }
          customClass="months"
          options={ getMonths }
          component={ renderDropbox }
          onClick={ onClick }
        />
        <Field
          name={ `${fieldGroupName}day` }
          customClass="days"
          options={ getDays() }
          component={ renderDropbox }
          onClick={ onClick }
        />
        <Field
          name={ `${fieldGroupName}year` }
          customClass="years"
          options={ getYears() }
          component={ renderDropbox }
          onClick={ onClick }
        />
      </div>
      {showError && <label className="ui label basic error-message">{day.meta.error.invalid ? invalidErrorMessage : errorMessage}</label>}
    </Form.Group>);
};

export default renderDate;
